/** PNG text fields for saved plates: tEXt chunks (Latin-1), inserted right after IHDR. */
const CRC = (() => {
  const t = new Uint32Array(256);
  for (let n = 0; n < 256; n++) { let c = n; for (let k = 0; k < 8; k++) c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1; t[n] = c >>> 0; }
  return t;
})();
export const crc32 = (b: Uint8Array) => { let c = 0xffffffff; for (const x of b) c = CRC[(c ^ x) & 0xff]! ^ (c >>> 8); return (c ^ 0xffffffff) >>> 0; };
const latin1 = (s: string) => Uint8Array.from([...s].map((ch) => { const c = ch.charCodeAt(0); return c < 256 ? c : 63; }));

export function textChunk(keyword: string, text: string): Uint8Array<ArrayBuffer> {
  const data = new Uint8Array([...latin1(keyword), 0, ...latin1(text)]);
  const out = new Uint8Array(12 + data.length);
  const v = new DataView(out.buffer);
  v.setUint32(0, data.length);
  out.set(latin1("tEXt"), 4);
  out.set(data, 8);
  v.setUint32(8 + data.length, crc32(out.subarray(4, 8 + data.length)));
  return out;
}

export async function withText(png: Blob, fields: Record<string, string>): Promise<Blob> {
  const bytes = new Uint8Array(await png.arrayBuffer());
  const ihdrEnd = 8 + 12 + new DataView(bytes.buffer).getUint32(8);
  const chunks = Object.entries(fields).map(([k, t]) => textChunk(k, t));
  return new Blob([bytes.slice(0, ihdrEnd), ...chunks, bytes.slice(ihdrEnd)], { type: "image/png" });
}

